<template lang="pug">
.v-text-page-section.text-page-section(v-if="data" :id="data?.id")
	//.text-page-section__wrapper
	.labels(v-if="data.labels && data.labels.length")
		.labels__item(v-for="label in data.labels" :class="[label.type ? 'labels__item--' + label.type : '']") {{ label.text }}
	h1.h1(v-if="data.title") {{ data.title }}
	.text-page-section__inner.text-guide(v-if="data.items && data.items.length" v-for="item in data.items")
		h3.h3(v-if="item.title") {{ item.title }}
		div(v-if="item.content" v-html="item.content")
	.text-page-section__actions(v-if="data.actions && data.actions.length")
		a.text-page-section__action.btn.btn.btn--primary(v-for="action in data.actions" :href="action.link" :class="action.className") {{action.text}}
			v-svg-icon.btn__arrow(icon="simple-arrow-left-sm")
</template>

<script>

import sourceMixin from "./mixins/v-mixin-source.vue";

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null,
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},
	}
}

</script>
